import { AssessmentDefinition } from "../../../../../noctem-lib/src/core/contracts/models.calculations";


export const preFieldSurveySoldier: AssessmentDefinition = {
  name: 'pre-field-soldier',
  description: 'Pre Field Soldier',
  instructions: null,
  questions: []
};
